import React from "react";
import { Button } from "reactstrap";
import TableContainerWarehouseRx from "../../../../../components/Common/TableContainerWarehouseRx";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../../components/Common/withRouter";

const DeductionTable = ({
  tableData,
  deductionColumns,
  assignedDeductions,
  openDeleteModal,
  openDisableModal,
  handleDisableDeduction,
  isDeleting,
  isDisabling,
  t,
}) => {
  // Ajout de la colonne Actions avec Delete et Disable
  const columnsWithActions = [
    ...deductionColumns,
    {
      header: "Actions",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }) => {
        const assigned = row.original;

        const stopEvent = (e) => e.stopPropagation();

        const handleDelete = (e) => {
          e.preventDefault();
          e.stopPropagation();
          openDeleteModal(assigned);
        };

        const handleDisable = (e) => {
          e.preventDefault();
          e.stopPropagation();
          openDisableModal(assigned);
        };

        return (
          <div className="d-flex gap-1" onClick={stopEvent} onMouseDown={stopEvent}>
            {/* Bouton Disable */}
            <Button
              color=""
              size="sm"
              onClick={handleDisable}
              onMouseDown={stopEvent}
              title="Disable"
              className="btn-sm px-2 py-1"
              disabled={isDisabling}
            >
              {isDisabling ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-ban" style={{ color: "#ffc107" }}></i>
              )}
            </Button>

            {/* Bouton Delete */}
            <Button
              color=""
              size="sm"
              onClick={handleDelete}
              onMouseDown={stopEvent}
              title="Supprimer"
              className="btn-sm px-2 py-1"
              disabled={isDeleting}
              style={{ zIndex: 1000 }}
            >
              {isDeleting ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-trash"></i>
              )}
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="mt-3">
      {assignedDeductions.length > 0 ? (
        <div className="card border-0 row p-2">
          <div className="card-header bg-white border-0 pb-0">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0">
                <i className="fa fa-list me-2 text-primary"></i>
                {t("Assigned_deductions")} ({assignedDeductions.length})
              </h6>
              <div className="text-muted small">
                {t("total")} :{" "}
                <span className="fw-bold text-danger">
                  {assignedDeductions
                    .reduce((total, ad) => total + (ad.calculatedAmount || 0), 0)
                    .toLocaleString()}{" "}
                  {t("XOF")}
                </span>
              </div>
            </div>
          </div>
          <div className="card-body">
            <TableContainerWarehouseRx
              columns={columnsWithActions}
              data={tableData}
              customPageSize={10}
              tableClass="table-borderless table-hover"
              theadClass="table-light"
              trClass=""
              tdClass=""
              divClass="table-responsive"
              tablePage={1}
              tableTotal={assignedDeductions.length}
              tableTotalPage={1}
              onNextPage={() => {}}
              t={t}
            />
          </div>
        </div>
      ) : (
        <div className="card border-0 row p-2">
          <div className="card-body text-center p-5">
            <div className="text-muted">
              <i className="fa fa-list-alt fa-3x mb-3 text-muted"></i>
              <h5 className="text-muted">{t("no_deductions_assigned")}</h5>
              <p className="text-muted">{t("select_deduction")}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default withRouter(withTranslation()(DeductionTable));
